//import manager from '@/utils/manager'
import api from '@/utils/api'

export function accountInfo(params) {
    return api.get('wx/v1/icelord/account', { params:params })
}

export function serverList(params) {
    return api.get('wx/v1/icelord/server', { params:params })
}

export function getServerList(params) {
    return api.get('wx/v1/icelord/get_server', { params:params })
}

export function getRoleList(params) {
    return api.get('wx/v1/icelord/get_role', { params:params })
}
export function getGameId(params) {
    return api.get('wx/v1/icelord/get_game', { params:params })
}

export function roleList(params) {
    return api.get('wx/v1/icelord/role', { params:params })
}

export function productsList(params) {
    return api.get('wx/v1/icelord/products', { params:params })
}
export function stripeMoneyList(params) {
    return api.post('stripe/moneyList', params)
}
export function createOrder(params) {
    return api.post('wx/v1/jzac', params)
}
export function payStripe(params) {
    return api.post('stripe/pay', params)
}

export function payThunderSnake(params) {
    return api.post('thundersnakePay/pay', params)
}

export function payLianLian(params) {
    return api.post('lianLianPay/pay', params)
}

export function pay(params) {
    return api.post('wx/v1/fenghuo/pay', params)
}

//支付包支付或paypel支付
export function payMix(params) {
    // return api.post('wx/v1/fenghuo/pay/mix', params)
    return api.post('wx/v1/official_account/pay', params)
}

//公众号微信支付--烽火
export function payWxRedirect(orderNum) {
    // return api.post('wx/v1/fenghuo/pay/wxRedirect', { order_num: orderNum })
    //    最新版公众号微信支付
    return api.post('wx/v1/official/common/wxpay', { order_num: orderNum, type: 1, project_id: 'fenghuo' })
}

export function commonCreateOrder(params) {
    return api.post('wx/v1/icelord/common/jzac', params)
}

//获取打金传说的活动
export function discountActivity(params)
{
    return api.post('wx/v1/gold/discount/activity', params)
}

//  mycard台湾支付
export function payMycard(params) {
    return api.post('mycardPay/pay', params)
}


